import { useMemo } from "react";
import { useHistory } from "react-router";
import {
  CartUpdateErrorModal,
  cartUpdateSelectors,
  CartUpdateState,
  getChildState,
  getParentState,
  ParentState,
  useCheckoutState,
  useCheckoutStateSelector as useSelector,
} from "@hopper-b2b/checkout";
import { useI18nContext } from "@hopper-b2b/i18n";
import { ErrorModal } from "@hopper-b2b/ui";
import Error from "../../../assets/client/error.svg";
import { PATH_FLIGHTS_SEARCH } from "../../../utils/urlPaths";
import type { TEvent } from "../events";
import type { FlightMachineContext } from "../types";

export const CartUpdateComponent = (props) => {
  const history = useHistory();
  const [state] = useCheckoutState<TEvent, FlightMachineContext>();
  const parentState = getParentState(state.value);
  const childState = getChildState(state.value);

  const cartUpdateError = useSelector(cartUpdateSelectors.getCartUpdateError);

  const { t } = useI18nContext();
  const loadingMessage = useMemo(() => {
    switch (parentState) {
      case ParentState.cartUpdate:
      case ParentState.cartUpdateBeforeFulfill:
        return t("loading");
      default:
        return "";
    }
  }, [parentState, t]);

  const errorState = useMemo(() => {
    return childState === CartUpdateState.error;
  }, [childState]);

  const { title, subtitle, primaryButtonText, primaryOnClick } = useMemo(() => {
    const cartUpdateErrorTypes = cartUpdateError?.type;

    const searchAgain = () => {
      history.push(PATH_FLIGHTS_SEARCH);
    };

    if (Array.isArray(cartUpdateErrorTypes)) {
      if (
        cartUpdateErrorTypes.includes(CartUpdateErrorModal.UnavailableCartState)
      ) {
        return {
          title: t("checkoutError.genericErrorTitle"),
          subtitle: t("checkoutError.genericErrorSubtitle"),
          primaryButtonText: t("checkoutError.searchAgain"),
          primaryOnClick: searchAgain,
        };
      }
    }
    return {
      title: t("checkoutError.genericErrorTitle"),
      subtitle: t("checkoutError.genericErrorSubtitle"),
      primaryButtonText: t("checkoutError.searchAgain"),
      primaryOnClick: searchAgain,
    };
  }, [cartUpdateError, t, history]);

  return errorState ? (
    <ErrorModal
      open={errorState}
      title={title}
      subtitle={subtitle}
      primaryButtonText={primaryButtonText}
      primaryOnClick={primaryOnClick}
      image={Error}
    />
  ) : null;
};
